import { render } from "./PersonnelGPRS.vue?vue&type=template&id=4af7d276"
import script from "./PersonnelGPRS.vue?vue&type=script&lang=js"
export * from "./PersonnelGPRS.vue?vue&type=script&lang=js"

import "./PersonnelGPRS.vue?vue&type=style&index=0&id=4af7d276&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__